import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useLocation, Link, useNavigate } from "react-router-dom";
import ApiHome from "../../../core/api/api.home";
// import { AlertCircle } from 'feather-icons-react';
// import {RotateCircleLoading	} from "react-loadingg"
import { Zoom } from "react-awesome-reveal";
import _ from "lodash";
import CardTile from "../../components/CardTile";
import CardTileSearch from "../../components/CardTileSearch";
import DottedLoadingData from "../../components/DottedLoadingData";
import { IconErrorCircle } from "../../../assets/icons";
function SearchPage() {

  let location = useLocation();
  const [searchList, setSearchList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        if (
          !_.isEmpty(location.state) &&
          !_.isEmpty(location.state.searchText)
        ) {
          let response = await ApiHome.getGlobalSearch(
            location.state.searchText
          );

          setIsLoading(false);

          if (response.succeeded == true) {
            setSearchList(response.data.amusementServiceS);

          } else {
          }
        } else {
          if (location.state.searchText == "") setIsLoading(false);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, [location]);
  const handleClick = (value) => { };
  return (
    <Container fluid className="bg-light-3">
      {/* {isMobile ? null :
                <Row className="pt-5 text-small">
                    <Col xs={12} className="px-0">
                        <div className="text-line">
                            <span className="rounded-pill bg-white border  py-2 px-3">
                                <Link to="/" className="text-muted"> صفحه اصلی </Link>{" "} / {" "}
                                <Link to="/List" className="text-muted font-weight-bold"> دسته بندی تفریحات کیش </Link>
                            </span>
                        </div>
                    </Col>
                </Row>
            } */}

      <Container className="pt-4 py-lg-4 min-height-page">
        {isLoading ? (
          <>
            <DottedLoadingData />
          </>
        ) : searchList?.length > 0 ? (
          <Row className={!isMobile ? "pt-3  gx-3" : " gx-0"}>
            {searchList?.map((itemData, index) => (
              <>
                <Col xs="12" sm="6" md="4" lg="3" className="mb-3">
                  <CardTileSearch
                    itemImgSrc={
                      process.env.REACT_APP_API_URL + itemData.imageUrl
                    }
                    amusementUrl={`/details/${itemData.urlName}`}
                    amusementName={itemData.name}
                    amusementPrice={itemData.price}
                    amusementFinalPrice={itemData.originalPrice}
                    handleClick={handleClick}
                  />
                </Col>
                {/* <ListItem
                  key={index}
                  itemTitle={itemData.name}
                  itemUrl={itemData.urlName}
                  itemImgSrc={itemData.imageUrl}
                  itemComment="12"
                  itemReserveDetails={_.attempt(
                    JSON.parse.bind(null, itemData.reserveDetails)
                  )}
                  // itemComment={itemData.itemComment}
                  // {...(itemData.amusementServiceOptionFields.length>0 ? {itemDiscount:itemData.amusementServiceOptionFields[0].discountPrice } : {})}
                  itemScore={itemData.totallyRankAverage}
                  // itemDiscount={itemData.discountPrice}
                  //itemDiscount={itemData.discount}
                  //itemDiscount={itemData.amusementServiceOptionFields.length>0 ? {itemDiscount:itemData.amusementServiceOptionFields[0].discountPrice} : 0 }
                  // itemPrice={itemData.amusementServiceOptionFields.length>0 ? {itemDiscount:itemData.amusementServiceOptionFields[0].price} : 0 }
                  itemPrice="0"
                  itemDiscount="0"
                /> */}
              </>
            ))}
          </Row>
        ) : (
          <div className="text-center  vh-100 xl-svg">
            <IconErrorCircle fillColor="#b1b1b1" />
            <div className="pb-4">اطلاعاتی جهت نمایش یافت نشد!</div>
          </div>
        )}
      </Container>
    </Container>
  );
}
export default SearchPage;
